var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaprapatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 46,
    viewBox: "0 0 59 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 43.9999C37.1667 44.1666 53.3 39.1999 56.5 17.9999C48.1667 17.6666 31.1 22.3999 29.5 43.9999Z",
    stroke: "#16AF8E",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 44.0161C21.3333 44.1827 5.2 39.2161 2 18.016C10.3333 17.6827 27.4 22.416 29 44.0161Z",
    stroke: "#16AF8E",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0104 23C17.836 19.8421 19.7897 11.4211 28.9999 3C38.2102 11.4211 40.164 19.8421 39.9896 23",
    stroke: "#16AF8E",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaprapatIcon);
export default __webpack_public_path__ + "static/media/naprapat-icon.3e0e32919b1b59c6e88b699190141895.svg";
export { ForwardRef as ReactComponent };